type ApigwResponseCodeKey =
    | 'SUCCESS'
    | 'FAIL'
    | 'NOT_AUTHORIZED'
    | 'NOT_AGREE'
    | 'TRANSACTION_STOP'
    | 'LEAVE'
    | 'DORMANCY'
    | 'NO_LOGIN_INFO'
    | 'NOT_REAL_NAME'
    | 'MEMBER_INFO_RETRIEVAL_FAILED'
    | 'TAMPERED_PAYMENT'
    | 'ERROR'
    | 'FAIL_REQUEST_VALIDATION'
    | 'FAIL_RESPONSE_VALIDATION'

/** APIGW 응답 코드 */
export const ApigwResponse: Record<ApigwResponseCodeKey, ApigwResponseType> = {
    SUCCESS: '00',
    FAIL: '10',
    NOT_AUTHORIZED: '20',
    NOT_AGREE: '21',
    TRANSACTION_STOP: '22',
    LEAVE: '23',
    DORMANCY: '24',
    NO_LOGIN_INFO: '25',
    NOT_REAL_NAME: '26',
    MEMBER_INFO_RETRIEVAL_FAILED: '29',
    FAIL_REQUEST_VALIDATION: '30',
    FAIL_RESPONSE_VALIDATION: '31',
    TAMPERED_PAYMENT: '91',
    ERROR: '99',
} as const

export const ApigwAuthErrors = [
    ApigwResponse.NOT_AUTHORIZED,
    ApigwResponse.NOT_AGREE,
    ApigwResponse.TRANSACTION_STOP,
    ApigwResponse.LEAVE,
    ApigwResponse.NOT_REAL_NAME,
    ApigwResponse.NO_LOGIN_INFO,
    ApigwResponse.MEMBER_INFO_RETRIEVAL_FAILED,
]
